export const SITE = {
  name: 'London Casino Deals',
  tagline: 'Your Trusted UK Casino Comparison Portal',
  description: 'Honest, independent reviews of licensed UK casino sites. Compare bonuses, games, and safety features in one place.',
  url: 'https://londoncasinodeals.com',
  email: 'info@londoncasinodeals.com',
};

/** UK National Gambling Helpline — free, confidential, 24/7 */
export const NATIONAL_GAMBLING_HELPLINE = '0808 8020 133';
export const NATIONAL_GAMBLING_HELPLINE_TEL = 'tel:08088020133';

export const TRUST_LINKS = [
  {
    name: 'UK Gambling Commission',
    url: 'https://www.gamblingcommission.gov.uk/',
    logo: '/logos/ukgc.webp',
    description: 'The official UK gambling regulator',
  },
  {
    name: 'GAMSTOP',
    url: 'https://www.gamstop.co.uk/',
    logo: '/logos/gamstop.jpg',
    description: 'Free self-exclusion service for UK players',
  },
  {
    name: 'GamCare',
    url: 'https://www.gamcare.org.uk/',
    logo: '/logos/gamcare.svg',
    description: 'Support and advice for problem gambling',
  },
  {
    name: 'BeGambleAware',
    url: 'https://www.begambleaware.org/',
    logo: '/logos/begambleaware.svg',
    description: 'Promoting safer gambling across the UK',
  },
];
